<div class="container">
  <h2 class="card-header" (click)="redirect()">
    {{ title | translate | uppercase }}
  </h2>
  <div class="main" (mouseover)="hovered = true" (mouseout)="hovered = false">
    <div class="offer-slider-content">
      <div
        class="offer-slider-content-container"
        [ngStyle]="getContainerStyle()"
      >
        <div
          class="offer-wrapper"
          *ngFor="let offer of offers; let i = index"
          (click)="clickOnSeeMore(offer)"
          [ngStyle]="{ width: 100 / offers.length + '%' }"
        >
          <img
            class="offer-slider-picture unselectable"
            *ngIf="offer.pictures[0]"
            src="{{ offer.pictures[0] }}"
            alt="property picture"
          />
          <div class="offer-info-container">
            <div class="info-left">
              <img
                class="pin"
                [src]="
                  'assets/images/pin-maps-' +
                  (title === 'SALES' ? 'sale.png' : 'rent.png')
                "
                alt=""
              />
              <div class="information">
                <div class="top">
                  {{ offer.subType | translatedb }}, {{ offer.space }} кв.м
                </div>
                <div class="bottom">{{ offer.area | translatedb }}</div>
              </div>
            </div>
            <div class="info-right">
              {{ offersService.getConvertedPrice(offer.price) }}€
            </div>
          </div>
        </div>
      </div>
      <div
        class="offer-slider-arrow-left-container"
        (click)="clickArrowLeft()"
        [@hovered]="hovered ? 'show' : 'hide'"
      >
        <div class="offer-slider-arrow-left"></div>
      </div>
      <div
        class="offer-slider-arrow-right-container"
        (click)="clickArrowRight()"
        [@hovered]="hovered ? 'show' : 'hide'"
      >
        <div class="offer-slider-arrow-right"></div>
      </div>
    </div>
  </div>
</div>
